<template>
  <tbody class="custom-table-bordered">
    <tr>
      <td colspan="2" class="font-weight-bold custom-td-header">
        <v-progress-circular
          v-if="loadingAvgDelivery"
          indeterminate
          color="primary"
        />
        Días hábiles tiempo de ciclo de venta
      </td>
      <template v-if="quarterly">
        <td
          v-for="(item, index) in avgDelivery"
          :key="`quarter-label-${index}`"
          class="custom-td-header font-weight-bold"
        >
          Trim {{ item.SPMON }}
        </td>
      </template>
      <template v-else>
        <td v-for="(item, index) in avgDelivery" :key="`month-value-${index}`">
          {{ formatNumber(item.AVGORDERS_DAYS, '', 1) }}
        </td>
      </template>
    </tr>
    <tr></tr>
    <tr class="custom-table-bordered">
      <td colspan="2">
        <div class="d-inline-flex">
          <v-checkbox
            v-model="quarterly"
            class="ml-2"
            :disabled="loadingAvgDelivery"
            dense
            @change="onQuarterlyChange"
          >
            <template #label>
              <div class="text-black">Trimestral</div>
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="monthly"
            class="ml-2"
            :disabled="loadingAvgDelivery"
            dense
            @change="onMonthlyChange"
          >
            <template #label>
              <div class="text-black">Mensual</div>
            </template>
          </v-checkbox>
        </div>
      </td>
      <template v-if="quarterly">
        <td
          v-for="(item, index) in avgDelivery"
          :key="`quarter-value-${index}`"
        >
          {{ formatNumber(item.AVGORDERS_DAYS, '', 1) }}
        </td>
      </template>
    </tr>
  </tbody>
</template>

<script>
  import axios from '@/plugins/axios';
  import numbers from '@/mixins/numbersFormats';
  import { isCancel } from '@/plugins/axios';

  export default {
    name: 'AvgDeliveryRows',
    mixins: [numbers],
    props: {
      username: {
        type: String,
        default: '',
      },
      chnl: {
        type: String,
        default: '',
      },
      disabledToRoles: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        loadingAvgDelivery: false,
        quarterly: true,
        monthly: false,
        avgDelivery: [],
      };
    },
    mounted() {
      this.avgBDaysForDelivery();
    },
    methods: {
      onQuarterlyChange(value) {
        this.quarterly = value;
        this.monthly = !value;
        this.avgBDaysForDelivery();
      },
      onMonthlyChange(value) {
        this.monthly = value;
        this.quarterly = !value;
        this.avgBDaysForDelivery();
      },
      async avgBDaysForDelivery() {
        this.loadingAvgDelivery = true;
        this.avgDelivery = [];
        try {
          const res = await axios.post(
            '/territorial-director/home/avg-bdays-for-delivery',
            {
              username: this.username,
              channel: this.chnl,
              isQuarter: this.quarterly ? 1 : 0,
            }
          );
          this.avgDelivery = res.data;
        } catch (error) {
          if (!isCancel(error)) {
            this.$toast.error('Hubo problemas al cargar días hábiles.');
          }
        }
        this.loadingAvgDelivery = false;
      },
    },
  };
</script>
